import React     from 'react'
import TabeeAuth from '@tabee/frontend-auth'

import {
    StaticPage,
    SignMethods,
    SiteNavigation,
    SocialNetworks,
    AccountContainer,
    AccountFooter,
    Spinner
} from 'components'

import { t } from 'tools'

import LoginLinks from './LoginLinks'
import connector  from './connector'
import './login.scss'

class Login extends React.Component {

    componentDidMount () {
        const
            params = new URLSearchParams( window.location.search ),
            returnURL = params.get( 'return_url' )

        ;( returnURL )
            ? TabeeAuth.SSOSignIn( `${window.location.host}/auth/sso`, `${encodeURIComponent( returnURL )}` )
            : TabeeAuth.SSOSignIn( `${window.location.host}/auth/sso` )
    }

    render () {
        return (
            <StaticPage>

                <SignMethods />

                <AccountContainer title={t( 'login.loginTitle' )}>

                    <div className="center-container">
                        <Spinner />
                    </div>

                    <LoginLinks />

                </AccountContainer>

                <AccountFooter>
                    <SiteNavigation />
                    <SocialNetworks />
                </AccountFooter>

            </StaticPage>
        )
    }
}

export default connector( Login )
